import React, { Component } from 'react'
import { Row, Card, Col, } from 'reactstrap'
import { SelectorCard, NullComp } from './'
import hasPermissionQ from '../../../helpers/users/manageUsers/hasPermissionQ';
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText';
import values from 'mout/object/values'
import isLicensedUser from '../../../helpers/users/licenses/isLicensedUser'
import getSchoolYear from '../../../helpers/getSchoolYear' 
import determineSchoolYear from '../../../helpers/determineSchoolYear'


class ManageClassesSelectorCard extends Component {
  state = {
    filter: '',
    teachers: null,
    loadingLicenses: false,
    licensedUsers: []
  }
  componentDidMount(){
    const { educators, year, schoolYearDataIndicator } = this.props;

    const teachers = values(educators).filter(ed => ed.role === 'Teacher')
    isLicensedUser(teachers, this.setState.bind(this))
    schoolYearDataIndicator(teachers);

    this.upDateState(educators, year)
  }

  componentDidUpdate(prevProps) {
    const { educators, year } = this.props;
    year !== prevProps.year && this.upDateState(educators, year)
  }

  upDateState = (educators, year) => {
    this.setState({
      teachers: values(educators).filter(ed => ed.role === 'Teacher' && 
      ((this.state.licensedUsers).includes(ed.id) && 
      determineSchoolYear(this.state.licenseEndDate).split('sy')[1] >= 
      getSchoolYear().year.split('sy')[1] && getSchoolYear().year == year) || 
      determineSchoolYear(ed.created) === year)
    })
  }
  render() {
    const { user } = this.props
    const { teachers } = this.state
    const role = user ? user.role : ''
    let schs = sortByPropText(values(this.props.schools), 'name')
    let color = '';
    if(schs.length===0)
    {
      color = '#ff9191';
    }
    // const teachers = values(this.props.educators).filter(ed => ed.role === 'Teacher')
    return (

      <SelectorCard>

        <SelectorCard.Header>Manage Classes</SelectorCard.Header>

        <SelectorCard.Instructions>
          Select the teacher whose classes you want to manage, then click 'Next' to continue.
        </SelectorCard.Instructions>


        {hasPermissionQ('Super Administrator', role)
          ? <SelectorCard.ProgressBar selectorName={'district'} />
          : <NullComp />
        }

        {hasPermissionQ('Super Administrator', role)
          ? <SelectorCard.DistrictSelect districts={this.props.districts} />
          : <NullComp />
        }


        {hasPermissionQ('District Admin', role)
          ? <SelectorCard.ProgressBar color = {color} selectorName={'school'}  schools={this.props.schools}/>
          : <NullComp />
        }

        {hasPermissionQ('District Admin', role)
          ? <SelectorCard.SchoolSelect
            
            schools={this.props.schools}
            role={role}
            color={color}
          />
          : <NullComp />
        }

        <SelectorCard.ProgressBar selectorName={'teacher'} />

        <SelectorCard.TeacherSelect
          teachers={teachers}
          role={role}
          schools={this.props.schools}
          color={color}
          baseLink='/users/manage/classes/'
        />



        <SelectorCard.Nav />


      </SelectorCard>
    )
  }
}

export default ManageClassesSelectorCard


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManageClassesSelectorCard.js